import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import makeStyles from "@mui/styles/makeStyles";
import SectionHeader from "../section-header/SectionHeader";
const useStyles = makeStyles(theme => ({
  boxContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "nowrap"
  },
  contentContainer: {
    display: "flex"
  },
  paperStyles: {
    borderRadius: 12,
    padding: 32,
    wordBreak: "break-word"
  },
  quote: {
    fontSize: 31,
    lineHeight: 1
  },
  contentText: {
    padding: "24px 0px"
  },
  [theme.breakpoints.up("md")]: {
    quote: {
      fontSize: 55
    }
  }
}));
const Testimonials = ({
  content,
  leftSpaceContainer,
  extraHeaderStyle = "",
  bottomSpaceContainer = ""
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    className: `${bottomSpaceContainer} ${leftSpaceContainer}`
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.header,
    extraHeaderStyle: extraHeaderStyle
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    spacing: 2,
    className: classes.boxContainer
  }, content.testimonials.map((item, index) => /*#__PURE__*/React.createElement(Grid, {
    sm: 6,
    xs: 12,
    item: true,
    key: index,
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: extraHeaderStyle === "" ? 0 : 1,
    className: classes.paperStyles
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    component: Typography,
    variant: "h2",
    className: classes.quote,
    color: "textPrimary"
  }, "\u201C"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 11
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary"
  }, item.header), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textPrimary",
    className: classes.contentText
  }, item.text), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textPrimary"
  }, item.author))))))));
};
Testimonials.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  extraHeaderStyle: PropTypes.string,
  bottomSpaceContainer: PropTypes.string
};
export default Testimonials;